export let mainTextColor = "#C39A6B"
export let mainBackgroundColor = "#FADADD"
export let mainBackgroundColorHover = "#FBE8D3"
export let buttonColor = "#91B8C8"
export let buttonColor2 = "#F7A6B2"
export let inactiveFields = "#F8F4EB"
export let mainFontColor = "#4B3B30"
export let decorative = "#F9B6A4"
